// One simple line icon for each design project, drawn as a standing badge on the map (24 by 24 box, ink strokes, no fill).
const D: Record<string, string> = {
  // architecture
  fox: 'M3 9h18M5 9v11M19 9v11M9 9v11M15 9v11M3 20h18M3 9l9-5 9 5',
  'turning-point': 'M8 21V4h8v17M8 9h8M8 14h8M5 21h14',
  'youth-oasis': 'M3 20l4-9 4 9M11 20l4-9 4 9M2 20h20',
  border: 'M2 20h20M2 14h20M5 14V9l1-3 1 3v5M11 14V9l1-3 1 3v5M17 14V9l1-3 1 3v5',
  'rum-and-ruin': 'M4 21V7M10 21V12M16 21V4M2 21h20M4 7h6',
  'project-river': 'M2 9c4-3 6 3 10 0s6 3 10 0M2 17c4-3 6 3 10 0s6 3 10 0M12 4v16',
  fortlandia: 'M3 20c0-9 5-14 9-14s9 5 9 14M8 20c0-5 2-8 4-8s4 3 4 8',
  wildflower: 'M3 20a9 9 0 0118 0M12 11v9M7 20c0-5 2-8 5-9M17 20c0-5-2-8-5-9',
  moxy: 'M5 20h12M7 16h12M5 12h12M7 8h12M5 4h12',
  // planning
  txst: 'M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z',
  'a-and-m': 'M3 4h7v16H3zM14 4h7v7h-7zM14 14h7v6h-7z',
  utsa: 'M2 20h20v-5H2zM15 15V4h4v11',
  noscut: 'M3 3h18v18H3zM3 12h18M12 3v18',
  'anna-maria': 'M3 20h18M5 20v-9h14v9M3 11l9-6 9 6M10 20v-5h4v5',
  tucson: 'M4 21V8h4v13M10 21V3h4v18M16 21V10h4v11',
  austin: 'M9 2v20M15 2v20M2 9h20M2 15h20',
  'net-zero': 'M3 20h18M5 20v-7h14v7M5 13l2-3h10l2 3M15 5.5a2.5 2.5 0 105 0 2.5 2.5 0 10-5 0',
  reframing: 'M2 14h20v6H2zM5 14V9h3v5M10 14V5h3v9M15 14v-6h3v6',
  // interviews
  storyteller: 'M3 3h18v11H3zM12 14v5M8 21h8',
  sga: 'M5 18h14l-2 3H3zM6 12h14l-2 3H4zM7 6h14l-2 3H5z',
  storyn: 'M4 3h16v7H4zM5 14h14M5 17h14M5 20h14',
};
const cache = new Map<string, Path2D>();
export function iconPath(id: string): Path2D {
  let p = cache.get(id);
  if (!p) { p = new Path2D(D[id] ?? 'M4 4h16v16H4z'); cache.set(id, p); }
  return p;
}
